export const httpHeaderConfig = Object.freeze({
  Accept: "application/json",
  ["Content-Type"]: "application/json",
});
//export const base_url = "http://13.232.8.166:8000/api/v1/";
// export const base_url = "https://dev.haaagtech.com/api/v1/";
export const base_url = "https://upskillmeet.com/api/v1/";
const regexPattern = {
  numberWithDecimal: /^\d+(\.\d{1,2})?$/,
};
export const userNameValidation = {
  ...requiredValidation("User Name"),
  minLength: { value: 4, message: "Enter minimum 4 characters" },
  pattern: {
    value: /^[a-zA-Z0-9]*$/, // Regex to allow only alphanumeric characters
    message: "Username cannot contain special characters",
  },
};
export const emailValidation = {
  ...requiredValidation("Email"),
  pattern: {
    value:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: "Enter a valid email",
  },
};
export const passwordValidation = {
  ...requiredValidation("Password"),
  minLength: { value: 8, message: "Enter minimum 8 characters" },
  pattern: {
    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#^$%!])[A-Za-z\d@#^$%!]{8,}$/,

    message:
      "Password must be 8 characters and include at least one lowercase letter, one uppercase letter, one number, and one special character",
  },
};
export const confirmPasswordValidation = (password, confirmPassword) => {
  return password === confirmPassword;
};
export const togglePasswordVisibility = (passwordInp) => {
  passwordInp.current.type =
    getPasswordType(passwordInp) === "password" ? "text" : "password";
};
export const getPasswordType = (passwordInp) => {
  return passwordInp.current.type;
};
const nameRegex = /^[A-Za-z]+$/;
export const addProfileValidation = {
  firstName: {
    ...requiredValidation("First Name"),
    minLength: { value: 3, message: "Enter minimum 3 characters" },
    pattern: {
      value: nameRegex,
      message:
        "First Name cannot contain spaces, numbers, or special characters",
    },
  },
  lastName: {
    ...requiredValidation("Last Name"),
    pattern: {
      value: nameRegex,
      message:
        "Last Name cannot contain spaces, numbers, or special characters",
    },
  },
  dob: {
    ...requiredValidation("DOB"),
    validate: (date) =>
      checkTimeGreaterThanCurrentDate({
        type: "dob",
        year: new Date(date).getFullYear(),
      }) || "Age must be atleast 18",
  },
  gender: requiredValidation("Gender"),
  timeZone: requiredValidation("Timezone"),
  contactNo: {
    // ...requiredValidation("Contact Number"),
    // pattern: {
    //   value: /^[0-9]+$/,
    //   message: "Enter valid contact details",
    // },
    // minLength: { value: 8, message: "Number should be atleast 8 characters" },
    // maxLength: { value: 15, message: "Number should be atleast 15 characters" },
  },
  whatsappNo: {
    // pattern: {
    //   value: /^[0-9]+$/,
    //   message: "Enter valid contact details",
    // },
    // ...requiredValidation("Whatsapp Number"),
    // minLength: { value: 8, message: "Number should be atleast 8 characters" },
    // maxLength: {
    //   value: 15,
    //   message: "Number should not be more than 15 characters",
    // },
  },
  location: {
    //...requiredValidation("Location"),
    pattern: {
      value: /^[a-zA-Z]+$/,
      message: "Enter a valid location",
    },
    language: {
      //...requiredValidation("Language")
    },
    link: {
      pattern: {
        value:
          /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi,
        message: "Enter a valid location",
      },
    },
  },
  country: {
    // ...requiredValidation("Country"),
  },
  state: {
    // ...requiredValidation("State"),
  },
  city: {
    // ...requiredValidation("City"),
  },
  experiences: {
    ...requiredValidation("experiences"),
  },
};
export const addEducationValidation = {
  school: {
    // ...requiredValidation("School"),
    pattern: {
      value: /^[a-zA-Z\s]+$/,
      message: "Enter a valid school name",
    },
  },
  college: {},
  className: {
    // ...requiredValidation("Qualification"),
    // pattern: {
    //   value: /^[a-zA-Z\s]+$/,
    //   message: "Enter a valid qualification name",
    // },
  },
  startYear: {
    // ...requiredValidation("Start Year"),
    validate: (date) => {
      return (
        !checkTimeGreaterThanCurrentDate({ type: "future", date }) ||
        "Enter valid date"
      );
    },
  },
  endYear: {
    // ...requiredValidation("End Year"),
    validate: (date) => {
      return (
        !checkTimeGreaterThanCurrentDate({ type: "future", date }) ||
        "Enter valid date"
      );
    },
  },
};
export const addProfessionValidation = {
  companyName: requiredValidation("Company Name"),
  position: requiredValidation("Position"),
  workExperience: {
    ...requiredValidation("Work Experience"),
    // pattern: {
    //   value: regexPattern.numberWithDecimal,
    //   message: "Enter valid work experience",
    // },
    maxLength: {
      value: 255, // Change this value as needed
      message: "Enter valid work experience",
    },
  },
  interest: requiredValidation("Interest"),
  skills: requiredValidation("Skills"),
  experties: requiredValidation("Experties"),
};
export const addPasswordOtpValidation = {
  ...requiredValidation(""),
  valueAsNumber: true,
  minLength: { value: 4 },
  validate: (num) => {
    return num <= 9 || "Invalid";
  },
};

export function checkTimeGreaterThanCurrentDate(toBeValidated) {
  if (toBeValidated.type === "dob") {
    const d =
      new Date().getFullYear() -
        new Date("" + toBeValidated.year).getFullYear() >
      18;
    return d;
  } else if (toBeValidated.type === "future") {
    const d = new Date(toBeValidated.date).getTime() > new Date().getTime();
    return d;
  } else if (toBeValidated.type === "compare") {
    const { startDate, endDate } = toBeValidated;
    const d =
      new Date(startDate).getTime() > new Date(endDate).getTime() ||
      new Date(startDate).getTime() === new Date(endDate).getTime();
    return d;
  }
  return true;
}

function twoDateComaprision(toBeValidatedDate, toBeComparedDate) {
  return (
    new Date(toBeValidatedDate).getTime() > new Date(toBeComparedDate).getTime()
  );
}
export function requiredValidation(fieldName) {
  return {
    required: {
      value: true,
      message: `${fieldName} is required`,
    },
  };
}
export const sociallogConfig = {
  clientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
  redirectUrl: `${window.location.origin}/auth/linkedin/callback`,
  oauthUrl:
    "https://www.linkedin.com/oauth/v2/authorization?response_type=code",
  scope: "openid profile w_member_social email",
  state: "123456",
};

export const chatConfig = {
  apiKey: process.env.REACT_APP_PUSHER_API_KEY,
  cluster: process.env.REACT_APP_PUSHER_CLUSTER,
};

export const autoTabField = async ({ setFocus, current, next }) => {
  try {
    if (current.register.name === "inp4") return;
    if ((current.value || current.value === 0) && !next.value)
      setFocus(next.register.name);
  } catch (err) {
    //console.log(err);
  }
};
export const dateMinOrMaxValidator = (config = {}) => {
  const { max, years } = config;
  let date = null;
  if (max && years) {
    const maxYear = new Date().getFullYear() - years;
    date = new Date("" + maxYear);
  }
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};

export function errorResponseMessage(errorObject) {
  return errorObject?.response?.data?.message || "Error";
}

export function dataURItoBlob(dataURI) {
  // console.log("mans", dataURI);
  const byteString = atob(dataURI.split(",")[1]);
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
}
export const imageCropMinMax = {
  minCroppedWidth: 400,
  minCroppedHeight: 400,
  maxCroppedWidth: 1200,
  maxCroppedHeight: 1000,
};

export const indiaCountryCode = 101;

export const addEditServiceValidation = {
  serviceName: requiredValidation("Service Name"),
  duration: requiredValidation("Duration"),
  amount: {
    ...requiredValidation("Amount"),
    pattern: {
      value: /^(?!0\d)[0-9]*$/,
      message:
        "Amount should not contain leading zeros followed by non-zero digits",
    },
  },
  noOfSessions: {
    ...requiredValidation("noOfSessions"),
    pattern: {
      value: /^(?!0\d)[0-9]*$/,
      message:
        "Session should not contain leading zeros followed by non-zero digits",
    },
  },
};

export const addEditProductValidation = {
  productName: {
    ...requiredValidation("Product Name"),
    minLength: {
      value: 3,
      message: "Product name must be at least 3 characters",
    },
    maxLength: {
      value: 100,
      message: "Product name cannot exceed 100 characters",
    },
    pattern: {
      value: /^[a-zA-Z0-9\s\-_]+$/,
      message:
        "Product name can only contain letters, numbers, spaces, hyphens and underscores",
    },
  },
  type: {
    ...requiredValidation("Type"),
  },
  url: {
    ...requiredValidation("url"),
    pattern: {
      value: /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/,
      message: "Please enter a valid URL (e.g., https://example.com)",
    },
  },
};

export const followerApiStatus = {
  request: "R",
  accept: "A",
  cancel: "C",
};

export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
